//@ts-check
import { ResourceManager } from "../engine";
import { Vector2D } from "../engine/vector";
import { Graphics } from "../engine/graphics";
import { ENTITY_STATE_DEFAULT, GAMETYPE_BEST_OF, NO_PLAYER, PLAYER_1, PLAYER_2, BALL_TYPE_DEFAULT, NO_TUTORIAL_STEP } from "../global";

/**
 * Entity
 */
export class Entity {
    constructor() {
        this.resource = null;
        this.position = new Vector2D();
        this.center = new Vector2D();
        this.velocity = new Vector2D();
        this.motion = new Vector2D();
        this.friction = 1;
        this.elasticity = 1;
        this.maxSpeed = 20;
        this.radius = 25;
        this.state = ENTITY_STATE_DEFAULT;
    }
}

/**
 * Ball
 */
export class Ball extends Entity {
    constructor() {
        super();
        this.type = BALL_TYPE_DEFAULT;
        this.ancle = Math.random() * 360;
        this.fuse = 0;
        this.friction = 0.8;
        this.elasticity = 0.6;
    }
}

/**
 * PlayerEye
 */
export class PlayerEye {
    constructor(position, radius, size) {
        this.position = position;
        this.radius = radius;
        this.size = size;
    }
}

/**
 * Player
 */
export class Player extends Entity {
    constructor(id) {
        super();
        this.id = id;
        this.score = 0;
        this.acceleration = 0.6;
        this.eye1 = new PlayerEye(new Vector2D(7, -35), 5, 1.1);
        this.eye2 = new PlayerEye(new Vector2D(15, -35), 4, 0.8);
        this.elasticity = 0.9;
        this.center.pos(0, -30);
        this.resourceCharred = null;
    }

    load(resourceId) {
        // Load player
        Object.assign(this, ResourceManager.resource("players/" + resourceId));

        // Load graphics
        this.drawable = new Graphics(this.resource);
        this.drawable.recalcBounds = function(bounds) {
            bounds.y1 = -bounds.height();
            bounds.y2 = 1;
            return bounds;
        };

        this.drawableCharred = new Graphics(this.resourceCharred);
        this.drawableCharred.recalcBounds = this.drawable.recalcBounds;
    }
}

/**
 * Level
 */
export class Level {
    constructor() {
        this.layers = [];
    }

    load(resourceId) {
        // Load level
        Object.assign(this, ResourceManager.resource("levels/" + resourceId));

        // Load graphics
        for (var i = 0; i < this.layers.length; i++) {
            var layer = this.layers[i];
            layer.graphics = new Graphics(layer.resource);
        }
    }
}

/**
 * GameState
 */
export class GameState {
    constructor() {
        this.difficulty = 0;
        this.levelResource = null;
        this.player1Resource = null;
        this.player2Resource = null;
        this.type = GAMETYPE_BEST_OF;
        this.logic = 0;
        this.gravity = 1.7;
        this.ground = 80;
        this.wall = 190;
        this.groundElasticity = 0.2;
        this.player1Start = new Vector2D(-60, this.ground);
        this.player2Start = new Vector2D(60, this.ground);
        this.ballForPlayer1Start = new Vector2D(-50, -20);
        this.ballForPlayer2Start = new Vector2D(50, -20);
        this.cameraScrollFactor = 0.25;
        this.cameraFake3DScale = 0.125;
        this.netTipRadius = 3;
        this.netTipY = -25;
        this.ball = new Ball();
        this.player1 = new Player(PLAYER_1);
        this.player2 = new Player(PLAYER_2);
        this.camera = new Vector2D();
        this.turn = PLAYER_1;
        this.lastContact = NO_PLAYER;
        this.tutorialStep = NO_TUTORIAL_STEP;
        this.timeDirection = 1;
        this.maxContacts = 5;
        this.playerJumpForce = 18;
        this.explosionMark = 0;
        this.level = new Level();
    }
}
